import script from "./BaseSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSection.vue?vue&type=script&lang=ts&setup=true"

import "./BaseSection.vue?vue&type=style&index=0&id=2fca951f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fca951f"]])

export default __exports__